import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Tag } from '@/js/libs/ui/src/V2';

import {
  TranslationItem,
  TranslationMeta,
  TranslationMetaItem,
  TranslationMetaLabel,
  TranslationMetaValue,
  TranslationValue,
} from './styled.ts';
import type { TrackedTranslation } from './types.ts';

type Props = {
  translation: TrackedTranslation;
  onClick: (translation: TrackedTranslation) => void;
};

export const TranslationListItem = memo(function TranslationListItem({ translation, onClick }: Props) {
  const [t] = useTranslation(['common']);
  const handleClick = useCallbackRef(() => onClick(translation));

  return (
    <TranslationItem onClick={handleClick} data-testid={`translation-item-${translation.fullKey}`}>
      <TranslationMeta>
        <TranslationMetaItem>
          <TranslationMetaLabel>{`${t('common:NAMESPACE')}:`}</TranslationMetaLabel>
          <Tag title={translation.namespace} />
        </TranslationMetaItem>
        <TranslationMetaItem>
          <TranslationMetaLabel>{`${t('common:KEY')}:`}</TranslationMetaLabel>
          <TranslationMetaValue>{translation.key}</TranslationMetaValue>
        </TranslationMetaItem>
      </TranslationMeta>
      <TranslationValue>{translation.value}</TranslationValue>
    </TranslationItem>
  );
});
